module.exports = __webpack_public_path__ + "static/media/protect-3.7c891ddf.png";